import { UncubesQuery } from '@dynameat/views/reporting/models';

export class AverageDinerTimeQuery extends UncubesQuery {
  projection = 'group_ticket_sales'

  cuts = []

  aggregates = [
    { kpi: 'ticket_duration_diners', function: 'SUM' },
    { kpi: 'ticket_diners', function: 'SUM' }
  ]

  limit = 25

  constructor(pointOfSaleGuid, dateStart, dateEnd, isManaged) {
    super();
    this.cuts = [
      { expression: `point_of_sale_guid = '${pointOfSaleGuid}'` },
      { expression: `group_ticket_line_date between '${dateStart}' and '${dateEnd}'` }];
  }
}
